import { render, staticRenderFns } from "./orderNum.vue?vue&type=template&id=9861f84e&scoped=true&"
import script from "./orderNum.vue?vue&type=script&lang=js&"
export * from "./orderNum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9861f84e",
  null
  
)

export default component.exports